import { render } from "./ProjectStyleTwo.vue?vue&type=template&id=2ba793f5"
import script from "./ProjectStyleTwo.vue?vue&type=script&lang=js"
export * from "./ProjectStyleTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__